import React, { FC } from 'react';

import { Document, Font } from '@react-pdf/renderer';

import font from '../../assets/fonts/OpenSans-Regular.ttf';
import fontBold from '../../assets/fonts/OpenSans-Bold.ttf';
import fontMedium from '../../assets/fonts/OpenSans-Medium.ttf';
import fontLight from '../../assets/fonts/OpenSans-Light.ttf';
import { TableOfContents } from './TableOfContents';
import { TilePages } from './TilePages';
import { TilePageNumber, TilesData, translations } from './interfaces';
import { CoverPage } from './CoverPage';
import { IntroPage } from './IntroPage';
import { LastPage } from './LastPage';

Font.register({
  family: 'Open Sans',
  fonts: [
    { src: font, fontWeight: 'normal' },
    { src: fontBold, fontWeight: 'bold' },
    { src: fontMedium, fontWeight: 'medium' },
    { src: fontLight, fontWeight: 'light' }
  ]
});

interface MyDocumentProps {
  tilesData: TilesData[];
  translations: translations;
}

const MyDocument: FC<MyDocumentProps> = ({ tilesData, translations }) => {
  const tilePageNumber: TilePageNumber[] = [];

  return (
    <Document>
      <CoverPage translations={translations} />
      <IntroPage translations={translations} />
      <TableOfContents
        tilesData={tilesData}
        tilePageNumber={tilePageNumber}
        translations={translations}
      />
      <TilePages
        tilesData={tilesData}
        tilePageNumber={tilePageNumber}
        translations={translations}
      />
      <LastPage translations={translations} />
    </Document>
  );
};

export const MemoizedMyDocument = React.memo(MyDocument);
